<div class="ad-expansion-item" [ngClass]="{ 'ad-expansion-leaf': leaf }">
  <span class="ad-expansion-text" [style]="getStyle()">
    <i
      class="fa ad-expansion-icon"
      [ngClass]="{ 'fa-angle-down': expand, 'fa-angle-right': !expand }"
      (click)="expandChildren($event)"
    ></i>
    <span class="ad-expansion-left" [innerHTML]="title">
    </span>
    <div class="ad-expansion-right">
      <ng-container *ngIf="headerRightTpl">
        <span
          *ngTemplateOutlet="
            headerRightTpl;
            context: { title: title, data: data }
          "
        ></span>
      </ng-container>
    </div>
  </span>
  <div class="ad-expansion-sub-container" [hidden]="!expand">
    <ng-content></ng-content>
  </div>
</div>
